import { createStore } from "owa-satcheljs";
import type { ProfileEditorState } from "./schema/ProfileEditorState";

export const getStore: () => ProfileEditorState = createStore<ProfileEditorState>("NovaProfileEditor", {
    isVisible: false,
    mailboxInfo: undefined,
    targetWindowId: undefined,
});
